
import { Component, Input, Output, EventEmitter } from '@angular/core';

@Component({
  selector: 'service-address',
  templateUrl: '../../templates/partials/address-service.html'
})
export class AddressServiceComponent{

    @Input() userAddress;
    @Output() assignCleanerEmitter = new EventEmitter();

    constructor(){}

    public setClass(hour){
        if(hour.available == "notAvailable"){
            return ""
        }
        else if(hour.available == "available"){
            return "c-select-hours-cleaner__item--active";
        }
        else if(hour.available == "busy"){
            return "c-select-hours-cleaner__item--selected-" + hour.duration;
        }
        else if(hour.available == "selection"){
            return "c-select-hours-cleaner__item--selection-" + hour.duration;
        }

    }

    public assignCleaner(hour,cleaner) {
        if(hour["available"] == "selection"){
            this.assignCleanerEmitter.emit(cleaner);
        }
    }

}


// WEBPACK FOOTER //
// ./src/app/modules/services/components/dummy/address-service.component.ts